/**
 * 消息相关工具函数
 */

import type { ChatMessage, Character } from '../types';

/**
 * 生成唯一消息 ID
 */
let _idCounter = 0;
export const generateMessageId = (prefix: string = 'msg'): string => 
  `${prefix}-${Date.now()}-${++_idCounter}`;

/**
 * 构建扩展历史记录（包含尚未显示的消息）
 */
export const buildExtendedHistory = (
  currentMessages: ChatMessage[],
  newTexts: string[],
  speakerId: string,
): ChatMessage[] => [
  ...currentMessages,
  ...newTexts.map((text) => ({
    id: generateMessageId('pre'),
    senderId: speakerId,
    text,
    type: 'text' as const,
  })),
];

/**
 * 判断消息是否是组内的第一条
 */
export const isFirstInGroup = (
  messages: ChatMessage[],
  index: number
): boolean => {
  if (index === 0) return true;
  const prevMsg = messages[index - 1];
  const currentMsg = messages[index];
  return prevMsg.type !== 'text' || prevMsg.senderId !== currentMsg.senderId;
};

/**
 * 判断消息是否是组内的最后一条
 */
export const isLastInGroup = (
  messages: ChatMessage[],
  index: number
): boolean => {
  if (index === messages.length - 1) return true;
  const nextMsg = messages[index + 1];
  const currentMsg = messages[index];
  return nextMsg.type !== 'text' || nextMsg.senderId !== currentMsg.senderId;
};

/**
 * 获取消息发送者
 */
export const getMessageSender = (
  message: ChatMessage,
  charA: Character,
  charB: Character
): Character => 
  message.senderId === charA.id ? charA : charB;
